/** @jsxImportSource react */
import type { SVGProps } from 'react';
const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.03 6.97a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06 0l-5.5-5.5a.75.75 0 1 1 1.06-1.06L10 16.94l9.97-9.97a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default Check;
